import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, FolderKanban, FileText, Plus } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export function BottomNav() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (p) => (p === "/dashboard" ? pathname === p : pathname.startsWith(p));

  const navItems = [
    { key: "home", to: "/dashboard", icon: Home, label: t("nav.home") },
    { key: "cases", to: "/cases", icon: FolderKanban, label: t("nav.cases") },
    { key: "documents", to: "/documents", icon: FileText, label: t("nav.documents") },
  ];

  const Item = ({ item }) => {
    const Icon = item.icon;
    const active = isActive(item.to);
    return (
      <button
        data-testid={`nav-${item.key}`}
        onClick={() => navigate(item.to)}
        className="flex flex-1 flex-col items-center gap-0.5 py-1 transition-colors"
        style={{ color: active ? "#2D5A4C" : "#7A9488" }}
      >
        <Icon size={22} strokeWidth={active ? 2.4 : 1.9} />
        <span className="text-[10px] font-semibold">{item.label}</span>
      </button>
    );
  };

  return (
    <nav className="fixed bottom-0 left-1/2 z-50 flex w-full max-w-md -translate-x-1/2 items-end justify-around border-t border-[#E2EAE5] bg-white/95 px-4 py-2 shadow-[0_-4px_24px_rgba(26,46,38,0.06)] backdrop-blur-md">
      {navItems.slice(0, 2).map((item) => <Item key={item.key} item={item} />)}

      <div className="flex flex-1 justify-center">
        <button
          data-testid="new-document-button"
          onClick={() => navigate("/documents/new")}
          className="-mt-8 flex items-center justify-center rounded-full border-4 border-[#F8FAF8] bg-[#2D5A4C] p-4 text-white shadow-xl transition-all hover:bg-[#214439] active:scale-95"
          aria-label={t("doc.title")}
        >
          <Plus size={24} strokeWidth={2.6} />
        </button>
      </div>

      {navItems.slice(2).map((item) => <Item key={item.key} item={item} />)}
    </nav>
  );
}
